<ap-selector-select
    [label]="'debitCardSelector.label' | apContent"
    [options]="selectorOptions()"
    [formControl]="control()"
    [selectedOptions]="selectedOptions()"
    [selectionType]="selectionType"
    [multipleTitle]="'debitCardSelector.multiple.title'"
    [multipleText]="'debitCardSelector.multiple.text'"
    [messages]="messages"
    (clicked)="openModal()"
></ap-selector-select>
